import { thunk } from 'easy-peasy';
import type { TJobShowcaseStore } from '@model/Job/showcase/Showcase.type';
import { utilityThrowError } from '@utils/errors';
import type { TJob } from '@model/Job/Job.type';

export const showcaseStore: TJobShowcaseStore = {
  putShowcase: thunk(async (_, payload, helpers) => {
    const _actions = helpers.getStoreActions();
    const { jobId, ...rest } = payload;

    _actions.job.setLoading(true);
    _actions.job.setError(false);

    try {
      const res = await _actions.session.authFetch({
        endpoint: `/v1/employer-view/jobs/${jobId}/showcase-configuration`,
        requestOptions: {
          method: 'PUT',
          body: JSON.stringify(rest),
        },
      });

      _actions.job.setData(res as TJob);
      return res;
    } catch (error) {
      _actions.job.setError(true);
      utilityThrowError(error, 'Error to save showcase');
      return null;
    }
  }),

  deleteShowcase: thunk(async (_, payload, helpers) => {
    const { jobId } = payload;
    const _actions = helpers.getStoreActions();

    try {
      await _actions.session.authFetch({
        endpoint: `/v1/employer-view/jobs/${jobId}/showcase-configuration`,
        requestOptions: { method: 'DELETE' },
      });
    } catch (error) {
      _actions.job.setError(true);
      utilityThrowError(error, 'Error to save Showcase');
    }
  }),
};
